import React from 'react';
import { SubmenuItem } from '../../types/navigation.types';
import { NavLink } from 'react-router-dom';
import { cn } from 'lib/utils';

interface SidebarSubmenuProps {
  submenu: SubmenuItem[];
}

const SidebarSubmenu: React.FC<SidebarSubmenuProps> = ({ submenu }) => {
  return (
    <div className="flex gap-1 ml-6 mr-2">
      {/* <div className="w-px bg-[#CBCFCD]"></div> */}
      <div className="flex flex-col">
        {submenu.map((subItem) => (
          <NavLink
            onClick={(e) => {
              if (subItem.comingSoon) e.preventDefault();
            }}
            key={subItem.id}
            to={subItem.path || '#'}
            className={({ isActive }) =>
              `relative flex items-center px-4 py-2 cursor-pointer rounded transition-colors hover:text-text-selected ${
                isActive
                  ? 'text-primary font-bold' // Active styles
                  : 'hover:font-medium text-text-primary font-normal' // Default styles
              } ${subItem.comingSoon ? 'cursor-not-allowed hover:text-text-primary' : ''}`
            }
          >
            <span
              className={cn('ml-3 text-[13px]', subItem.comingSoon && 'ml-2')}
            >
              {subItem.text}
            </span>
            {subItem.comingSoon && (
              <span className="absolute -right-12 text-[10px] text-[#846CEC] ml-2 px-1 py-[2px] bg-[#846CEC20] rounded-full border border-[#846CEC] whitespace-nowrap">
                Upcoming
              </span>
            )}
          </NavLink>
        ))}
      </div>
    </div>
  );
};

export default SidebarSubmenu;
